(() => {
  const DESKTOP_QUERY = '(min-width: 1025px)';
  const OPEN_PANEL_CLASSES = ['visible', 'left-0', 'opacity-100'];
  const CLOSED_PANEL_CLASSES = ['invisible', '-left-full', 'opacity-0'];
  const ACTIVE_TAB_CLASSES = ['desktop:bg-black', 'desktop:text-white'];
  // The reference header renders the burger and its close cross from the same
  // sprite, swapping only the symbol; the shell is drawn at 0.625 zoom, so any
  // viewport measurement has to be divided back out before it is applied.
  const MENU_ICON_CLOSED = 'header-menu';
  const MENU_ICON_OPEN = 'header-menu-active';
  const HEADER_SCALE = 0.625;
  // The same collection reaches this file percent-encoded from one source and
  // literal from the other, so every comparison and lookup goes through here.
  const decodePath = (path) => {
    try {
      return decodeURIComponent(String(path));
    } catch {
      return String(path);
    }
  };
  const isRealLabel = (value) =>
    typeof value === 'string' && value.trim() !== '' && !/^translation missing/i.test(value.trim());
  // Only the sale mega panel used these filtered collection URLs, and that panel
  // is commented out below; kept so putting it back stays a single revert.
  // const saleFilter = (...types) => `/collections/indirim?${types.map((type) => `filter.p.product_type=${encodeURIComponent(type)}`).join('&')}`;

  const navigation = {
    tr: {
      basic: {
        label: 'basic™',
        landing: '/pages/gi%CC%87esto-basic',
        all: '/collections/basic',
        clothing: 'GİYİM',
        categories: [
          ['Atlet', '/collections/basic-atlet'],
          ['T-shirt', '/collections/basic-t-shirt-1'],
          ['Triko', '/collections/basic-triko'],
          ['Gömlek', '/collections/basic-gomlek-1'],
          ['Sweatshirt', '/collections/basic-sweatshirt'],
          ['Hırka', '/collections/basic-hirka'],
          ['Ceket', '/collections/basic-ceket-1'],
          ['Trençkot', '/collections/basic-trenckot'],
          ['Kaban', '/collections/basic-kaban'],
          ['Pantolon', '/collections/basic-pantolon-1'],
          ['Jean', '/collections/basic-jean-1'],
          ['Eşofman', '/collections/basic%E2%84%A2-esofman'],
          ['Ayakkabı', '/collections/basic-ayakkabi'],
          ['Boxer', '/collections/basic-boxer'],
          ['Çorap', '/collections/basic-corap'],
          ['Aksesuar', '/collections/basic-aksesuar'],
        ],
      },
      newSeason: {
        label: 'Yeni Sezon',
        landing: '/pages/fw27',
        all: '/collections/tumunu-gor-f-w27',
        clothing: 'GİYİM',
        categories: [
          ["KABAN", "/collections/kaban-f-w27"],
          ["MONT", "/collections/mont-f-w27"],
          ["TRENÇKOT", "/collections/trenckot-f-w27"],
          ["CEKET", "/collections/ceket-f-w27"],
          ["HIRKA", "/collections/hirka-f-w27"],
          ["KAZAK", "/collections/kazak-f-w27"],
          ["TRİKO", "/collections/tri̇ko-f-w27"],
          ["SWEATSHIRT", "/collections/sweatshirt-f-w27"],
          ["GÖMLEK", "/collections/gomlek-f-w27"],
          ["T-SHIRT", "/collections/t-shirt-f-w27"],
          ["PANTOLON", "/collections/pantolon-f-w27"],
          ["JEAN", "/collections/jean-f-w27"],
          ["EŞOFMAN", "/collections/esofman-f-w27"],
        ],
      },
      sale: {
        label: 'SALE',
        landing: '/collections/indirim',
        // The sale mega panel is commented out in giesto-canonical-header-markup.liquid,
        // so nothing reads these groups; they stay for whenever the panel comes back.
        // groups: [
          // { index: 2, label: 'GİYİM', items: [['Tümünü Gör', saleFilter('CEKET', 'GÖMLEK', 'HIRKA', 'JEAN', 'KABAN', 'KAZAK', 'MONT', 'PANTOLON', 'ŞORT', 'SWEATSHIRT', 'T-SHIRT')], ['T-shirt', saleFilter('T-SHIRT')], ['Gömlek', saleFilter('GÖMLEK')], ['Triko ve Hırka', saleFilter('KAZAK', 'HIRKA')], ['Ceket ve Kaban', saleFilter('CEKET', 'MONT', 'KABAN')], ['Pantolon', saleFilter('PANTOLON')], ['Jean', saleFilter('JEAN')], ['Şort', saleFilter('ŞORT')]] },
          // { index: 3, label: 'AKSESUAR', items: [['Tümünü Gör', saleFilter('ÇANTA')], ['Çanta', saleFilter('ÇANTA')]] },
          // { index: 4, label: 'AYAKKABI', items: [['Tümünü Gör', saleFilter('AYAKKABI', 'BOT', 'SANDALET', 'TERLİK')], ['Ayakkabı', saleFilter('AYAKKABI')], ['Bot', saleFilter('BOT')], ['Sandalet', saleFilter('SANDALET')], ['Terlik', saleFilter('TERLİK')]] },
        // ],
      },
      // A destination rather than a panel, like SALE. The label here is the
      // fallback for a storefront whose locale file has no nav_all_products entry.
      allProducts: {
        label: 'Tüm Ürünler',
        landing: '/collections/tum-urunler',
      },
      allLabel: 'Tümünü Gör',
      search: 'Ara',
      account: 'Hesabım',
      wishlist: 'Favoriler',
      cart: 'Sepetim',
      close: 'Kapat',
      menu: 'Menü',
    },
    en: {
      basic: {
        label: 'basic™',
        landing: '/pages/gi%CC%87esto-basic',
        all: '/collections/basic',
        clothing: 'CLOTHING',
        categories: [
          ['Tank tops', '/collections/basic-atlet'],
          ['T-shirts', '/collections/basic-t-shirt-1'],
          ['Knitwear', '/collections/basic-triko'],
          ['Shirts', '/collections/basic-gomlek-1'],
          ['Sweatshirts', '/collections/basic-sweatshirt'],
          ['Cardigans', '/collections/basic-hirka'],
          ['Jackets', '/collections/basic-ceket-1'],
          ['Trench coats', '/collections/basic-trenckot'],
          ['Coats', '/collections/basic-kaban'],
          ['Trousers', '/collections/basic-pantolon-1'],
          ['Jeans', '/collections/basic-jean-1'],
          ['Sweatpants', '/collections/basic%E2%84%A2-esofman'],
          ['Shoes', '/collections/basic-ayakkabi'],
          ['Boxers', '/collections/basic-boxer'],
          ['Socks', '/collections/basic-corap'],
          ['Accessories', '/collections/basic-aksesuar'],
        ],
      },
      newSeason: {
        label: 'New Season',
        landing: '/pages/fw27',
        all: '/collections/tumunu-gor-f-w27',
        clothing: 'CLOTHING',
        categories: [
          ["COATS", "/collections/kaban-f-w27"],
          ["JACKETS", "/collections/mont-f-w27"],
          ["TRENCH COATS", "/collections/trenckot-f-w27"],
          ["BLAZERS", "/collections/ceket-f-w27"],
          ["CARDIGANS", "/collections/hirka-f-w27"],
          ["SWEATERS", "/collections/kazak-f-w27"],
          ["KNITWEAR", "/collections/tri̇ko-f-w27"],
          ["SWEATSHIRTS", "/collections/sweatshirt-f-w27"],
          ["SHIRTS", "/collections/gomlek-f-w27"],
          ["T-SHIRTS", "/collections/t-shirt-f-w27"],
          ["TROUSERS", "/collections/pantolon-f-w27"],
          ["JEANS", "/collections/jean-f-w27"],
          ["TRACKSUITS", "/collections/esofman-f-w27"],
        ],
      },
      sale: {
        label: 'SALE',
        landing: '/collections/indirim',
        // The sale mega panel is commented out in giesto-canonical-header-markup.liquid,
        // so nothing reads these groups; they stay for whenever the panel comes back.
        // groups: [
          // { index: 2, label: 'CLOTHING', items: [['View all', saleFilter('CARDIGAN', 'COAT', 'JACKET', 'JEAN', 'MOUNT', 'SHIRT', 'Shorts', 'SWEATER', 'SWEATSHIRT', 'T-SHIRT', 'TROUSERS')], ['T-shirts', saleFilter('T-SHIRT')], ['Shirts', saleFilter('SHIRT')], ['Knitwear', saleFilter('SWEATER', 'CARDIGAN')], ['Jackets and coats', saleFilter('JACKET', 'MOUNT', 'COAT')], ['Trousers', saleFilter('TROUSERS')], ['Jeans', saleFilter('JEAN')], ['Shorts', saleFilter('Shorts')]] },
          // { index: 3, label: 'ACCESSORIES', items: [['View all', saleFilter('BAG')], ['Bags', saleFilter('BAG')]] },
          // { index: 4, label: 'SHOES', items: [['View all', saleFilter('BOT', 'SANDAL', 'SHOES', 'SLIPPERS')], ['Shoes', saleFilter('SHOES')], ['Boots', saleFilter('BOT')], ['Sandals', saleFilter('SANDAL')], ['Slippers', saleFilter('SLIPPERS')]] },
        // ],
      },
      // A destination rather than a panel, like SALE. The label here is the
      // fallback for a storefront whose locale file has no nav_all_products entry.
      allProducts: {
        label: 'All products',
        landing: '/collections/tum-urunler',
      },
      allLabel: 'View all',
      search: 'Search',
      account: 'My account',
      wishlist: 'Wishlist',
      cart: 'My bag',
      close: 'Close',
      menu: 'Menu',
    },
  };

  class GiestoCanonicalHeader extends HTMLElement {
    connectedCallback() {
      this.root = this.shadowRoot;
      if (!this.root || this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.config = window.__giestoCanonicalHeader || {};
      this.locale = String(this.config.locale || 'tr').toLowerCase().startsWith('en') ? 'en' : 'tr';
      this.copy = navigation[this.locale];
      this.readNavData();
      this.header = this.root.querySelector('header');
      this.nav = this.root.querySelector('header nav');
      this.menuShell = this.root.querySelector('header nav > div');
      this.mobileMenuButton = this.root.querySelector('[data-testid="header-navigation-menu-button"]');
      this.mobileMenu = this.mobileMenuButton?.nextElementSibling;
      this.announcementTrigger = this.root.querySelector('section[role="banner"] > button[aria-haspopup="dialog"]');
      this.announcementDrawer = this.root.querySelector('[data-giesto-announcement-drawer]');
      this.topButtons = [...this.root.querySelectorAll('header nav > div > ul > li > button[data-menu]')];
      this.panels = [...this.root.querySelectorAll('header nav > div > div')];
      this.mobileMenuBackdrop = this.mobileMenu?.children[1];
      this.scrollLocked = false;
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onOutsidePointerDown = this.onOutsidePointerDown.bind(this);
      this.onOutsideClick = this.onOutsideClick.bind(this);
      this.onResize = this.onResize.bind(this);
      this.updateMenuHeight = this.updateMenuHeight.bind(this);
      this.syncWishlistCount = this.syncWishlistCount.bind(this);
      this.root.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('pointerdown', this.onOutsidePointerDown, true);
      window.addEventListener('click', this.onOutsideClick, true);
      document.addEventListener('giesto:wishlist:change', this.syncWishlistCount);
      window.addEventListener('resize', this.onResize, { passive: true });
      document.addEventListener('scroll', this.updateMenuHeight, { capture: true, passive: true });
      this.announcementObserver = new ResizeObserver(() => {
        const banner = this.announcementTrigger?.parentElement;
        const height = banner ? banner.getBoundingClientRect().height * this.pageScale : 0;
        this.closest('#header-group')?.style.setProperty('--giesto-announcement-height', `${height}px`);
        this.updateMenuHeight();
      });
      if (this.announcementTrigger) this.announcementObserver.observe(this.announcementTrigger.parentElement);
      this.configureNavigation();
      this.configureAnnouncement();
      this.configureUtilities();
      this.syncWishlistCount();
      this.onResize();
    }

    disconnectedCallback() {
      this.root?.removeEventListener('click', this.onClick);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('pointerdown', this.onOutsidePointerDown, true);
      window.removeEventListener('click', this.onOutsideClick, true);
      document.removeEventListener('giesto:wishlist:change', this.syncWishlistCount);
      this.setBodyScrollLock(false);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('scroll', this.updateMenuHeight, true);
      this.announcementObserver?.disconnect();
    }

    // The store's own navigation menus decide what the mega menu lists, so a
    // category added in Shopify admin appears without a deploy. The list is read
    // once: the archived page can rebuild its header later, and a header that
    // came back without the payload should keep the categories it already had.
    readNavData() {
      this.navMenus = {};
      this.navLabels = {};
      try {
        const source = this.root.querySelector('script[type="application/json"][data-giesto-nav-data]');
        const parsed = JSON.parse(source?.textContent || '{}');
        this.navMenus = parsed;
        this.navLabels = parsed.labels || {};
      } catch {
        // A malformed payload must not cost the visitor the whole header, so the
        // hardcoded list below stands in for it.
      }
      this.themeLabels = new Map(
        [...this.copy.basic.categories, ...this.copy.newSeason.categories].map(([label, path]) => [decodePath(path), label])
      );
    }

    // The Shopify language editor owns these labels, keyed by collection handle.
    // A handle it has no entry for falls back to the theme's own label, and then
    // to the title the menu itself carries — which is what a category published
    // today reads as until someone translates it.
    categoryLabel(path, menuTitle) {
      const decoded = decodePath(path);
      const translated = this.navLabels[decoded.split('/collections/')[1] || ''];
      if (isRealLabel(translated)) return translated.trim();
      return this.themeLabels.get(decoded) || menuTitle;
    }

    // The menu carries its own "Tümünü Gör" entry, but the header renders that
    // destination itself, first in the list, so it is dropped here.
    sectionCategories(key, section) {
      const published = this.navMenus[key];
      const all = decodePath(section.all);
      const categories = !Array.isArray(published) || published.length === 0
        ? section.categories
        : published.filter((entry) => Array.isArray(entry) && decodePath(entry[1]) !== all)
          .map(([title, path]) => [this.categoryLabel(path, title), path]);
      return categories.map(([label, path]) => [this.basicCategoryLabel(label), path]);
    }

    basicCategoryLabel(label) {
      const text = String(label).trim().toLocaleLowerCase(this.locale);
      return text.slice(0, 1).toLocaleUpperCase(this.locale) + text.slice(1);
    }

    localUrl(path) {
      const root = String(this.config.root || '/');
      return `${root.replace(/\/$/, '')}${path}` || path;
    }

    setAnchor(anchor, label, path) {
      if (!anchor) return;
      const text = anchor.querySelector('span') || anchor;
      const normalized = /^(tümünü gör|view all)$/iu.test(String(label).trim()) ? (this.locale === 'tr' ? 'TÜMÜNÜ GÖR' : 'VIEW ALL') : /^basic[™]?$/iu.test(String(label).trim()) ? 'basic™' : this.basicCategoryLabel(label);
      text.textContent = normalized;
      text.style.textTransform = 'none'; text.style.fontFamily = 'Arket Sans, Arial, sans-serif';
      anchor.href = this.localUrl(path);
      anchor.querySelector('[data-testid="new-marker"]')?.remove();
      anchor.closest('li')?.removeAttribute('hidden');
    }

    configureSection(menuIndex, submenuIndex, key, section) {
      const panel = this.root.querySelector(`header nav > div > div:nth-of-type(${menuIndex + 1})`);
      // The panel's own sticky header already names the section, so the repeated
      // collection title at the top of the list is a duplicate. Remove the whole
      // <li> rather than hiding it, so the links below close the gap.
      panel?.querySelector('ul:first-child > li:first-child')?.remove();
      const clothingButton = panel?.querySelector(`button[data-menu="${menuIndex}-${submenuIndex}"]`);
      const clothingLabel = clothingButton?.querySelector('div span');
      if (clothingLabel) { clothingLabel.textContent = this.basicCategoryLabel(section.clothing); clothingLabel.style.textTransform = 'none'; clothingLabel.style.fontFamily = 'Arket Sans, Arial, sans-serif'; }
      // The sticky header at the top of an open panel is the way back on
      // mobile. Only the sale panel relabelled its own, so these two kept the
      // Turkish they were captured with and showed it on /en/.
      const back = panel?.querySelector('button.sticky[data-level="0"] span');
      if (back) {
        back.textContent = key === 'basic' ? 'basic™' : this.basicCategoryLabel(section.label); back.style.textTransform = 'none'; back.style.fontFamily = 'Arket Sans, Arial, sans-serif';
        if (key === 'basic') back.lang = 'en';
      }
      const nestedBack = clothingButton?.nextElementSibling?.querySelector('button.sticky span');
      if (nestedBack) {
        nestedBack.textContent = `${key === 'basic' ? 'basic™' : this.basicCategoryLabel(section.label)} / ${this.basicCategoryLabel(section.clothing)}`;
        if (key === 'basic') nestedBack.lang = 'en';
      }
      const destinations = [[this.locale === 'tr' ? 'TÜMÜNÜ GÖR' : 'VIEW ALL', section.all], ...this.sectionCategories(key, section)];
      const anchors = [...this.root.querySelectorAll(`header nav a[data-menu^="${menuIndex}-${submenuIndex}-"]`)];
      this.growLinkSlots(anchors, destinations.length, `${menuIndex}-${submenuIndex}`);
      anchors.forEach((anchor, index) => {
        if (index < destinations.length) this.setAnchor(anchor, ...destinations[index]);
        else anchor.closest('li')?.setAttribute('hidden', '');
      });
    }

    // The archive captured a fixed number of link slots per section, so a menu
    // that has since grown past that count lost its last destinations without a
    // trace. Extend the list from its own last item, which keeps the captured
    // markup and classes and does nothing once the slots are already there.
    growLinkSlots(anchors, needed, prefix) {
      let last = anchors[anchors.length - 1];
      while (last && anchors.length < needed) {
        const item = last.closest('li');
        const clone = item?.cloneNode(true);
        const anchor = clone?.querySelector(`a[data-menu^="${prefix}-"]`);
        if (!anchor) return;
        anchor.dataset.menu = `${prefix}-${anchors.length}`;
        item.after(clone);
        anchors.push(anchor);
        last = anchor;
      }
    }

    configureNavigation() {
      // Only three tabs are buttons now: the third keeps the label it was
      // captured with, and SALE joined Tüm Ürünler as a plain link below.
      const labels = [this.copy.basic.label, this.copy.newSeason.label, ''];
      this.topButtons.forEach((button, index) => {
        if (labels[index]) { const text = button.querySelector('span') || button; text.textContent = index === 0 ? 'basic™' : this.basicCategoryLabel(labels[index]); text.style.textTransform = 'none'; text.style.fontFamily = 'Arket Sans, Arial, sans-serif'; }
        // The Basic brand uses Latin I/i even under Turkish text transforms.
        if (index === 0) (button.querySelector('span') || button).lang = 'en';
      });
      this.configureSection(0, 3, 'basic', this.copy.basic);
      this.configureSection(1, 1, 'newSeason', this.copy.newSeason);
      // The sale panel is commented out in giesto-canonical-header-markup.liquid,
      // so there is nothing left for configureSale() to fill in. Uncomment both
      // together to bring the panel back.
      // this.configureSale();
      this.configureDirectLinks();
    }

    // Storefront translations win over the built-in labels, so the shop can
    // rename these tabs from the Shopify language editor. A locale file missing
    // the key renders Shopify's "Translation missing" placeholder, which is
    // never a label worth painting.
    navLabel(key, fallback) {
      const value = this.config[key];
      if (typeof value !== 'string') return fallback;
      const label = value.trim();
      return !label || /^translation missing/i.test(label) ? fallback : label;
    }

    // SALE and Tüm Ürünler are destinations rather than panels, so they only
    // need a label and an href -- localised like every other link in here.
    configureDirectLinks() {
      const destinations = [
        ['sale', this.navLabel('saleLabel', this.copy.sale.label), this.copy.sale.landing],
        ['all-products', this.navLabel('allProductsLabel', this.copy.allProducts.label), this.copy.allProducts.landing],
      ];
      for (const [key, label, path] of destinations) {
        this.setAnchor(this.root.querySelector(`header nav a[data-giesto-nav-link="${key}"]`), label, path);
      }
    }

    /*
     * Filled in the sale mega panel, which is commented out in
     * giesto-canonical-header-markup.liquid now that the SALE tab links
     * straight to the collection. Kept so restoring the panel is one revert.
     *
     *     configureSale() {
     *       const sale = this.copy.sale;
     *       const panel = this.root.querySelector('header nav > div > div:nth-of-type(4)');
     *       panel?.querySelector(':scope > div > div > ul:nth-of-type(2)')?.remove();
     *       const directLinks = [...(panel?.querySelectorAll('ul:first-child > li > a') || [])];
     *       this.setAnchor(directLinks[0], sale.label, sale.landing);
     *       this.setAnchor(directLinks[1], this.copy.allLabel, sale.landing);
     *       for (const group of sale.groups) {
     *         const button = panel?.querySelector(`button[data-menu="3-${group.index}"]`);
     *         const label = button?.querySelector('div span');
     *         if (label) label.textContent = group.label;
     *         const backLabel = button?.nextElementSibling?.querySelector('button.sticky span');
     *         if (backLabel) backLabel.textContent = `${sale.label} / ${group.label}`;
     *         const anchors = [...this.root.querySelectorAll(`header nav a[data-menu^="3-${group.index}-"]`)];
     *         anchors.forEach((anchor, index) => {
     *           if (index < group.items.length) this.setAnchor(anchor, ...group.items[index]);
     *           else anchor.closest('li')?.setAttribute('hidden', '');
     *         });
     *       }
     *     }
     */

    configureUtilities() {
      // Every GIESTO360 lockup on the storefront opens the YouTube channel in a
      // new tab; the one in the navigation matches.
      for (const link of this.root.querySelectorAll('header nav a[href*="youtube.com/@giesto360"], header nav a[data-giesto-360]')) {
        link.setAttribute('aria-label', 'GIESTO 360');
        link.href = 'https://www.youtube.com/@giesto360';
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
        link.setAttribute('data-giesto-360', '');
        if (this.config.giesto360) link.style.backgroundImage = `url("${this.config.giesto360}")`;

        const item = link.closest('li');
        if (item && !item.parentElement?.querySelector('[data-giesto-blog-link]')) {
          const blogItem = document.createElement('li');
          const blogLink = document.createElement('a');
          blogLink.className = 'flex items-center hocus:underline desktop:px-8';
          blogLink.href = this.config.blogUrl || '/blogs/news';
          blogLink.dataset.giestoBlogLink = '';

          const blogLabel = document.createElement('span');
          blogLabel.className = 'font-regular bg-transparent text-black text-20 leading-26 desktop:text-16 desktop:leading-30';
          blogLabel.textContent = this.config.blogLabel || 'Blog';
          blogLink.append(blogLabel);
          blogItem.append(blogLink);
          item.after(blogItem);
        }
      }
      for (const lockup of this.root.querySelectorAll('header nav a[data-giesto-360]')) {
        const list = lockup.closest('li')?.parentElement;
        if (!list || list.querySelector('[data-giesto-contact-link]')) continue;
        const item = document.createElement('li');
        const anchor = document.createElement('a');
        anchor.className = 'flex items-center hocus:underline desktop:px-8';
        anchor.dataset.giestoContactLink = '';
        anchor.href = (this.config.locale === 'en' ? '/en' : '') + '/pages/iletisim';
        const label = document.createElement('span');
        label.className = 'font-regular bg-transparent text-black text-20 leading-26 desktop:text-16 desktop:leading-30';
        label.textContent = this.config.locale === 'en' ? 'Customer service' : 'Müşteri hizmetleri';
        anchor.append(label);
        item.append(anchor);
        (list.querySelector('[data-giesto-blog-link]')?.closest('li') || lockup.closest('li')).after(item);
      }
      const localeTemplate = this.root.querySelector('template[data-giesto-shopify-locale-template]');
      for (const control of this.root.querySelectorAll('[data-testid="location-selector-header"]')) {
        if (control.hasAttribute('data-giesto-language-switch')) continue;
        const switcher = localeTemplate?.content.firstElementChild?.cloneNode(true);
        if (!switcher) continue;
        switcher.removeAttribute('id');
        switcher.dataset.testid = 'location-selector-header';
        switcher.dataset.giestoLanguageSwitch = '';
        const returnTo = switcher.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = location.pathname + location.search;
        // Preview hosts lose the locale on POST /localization; explicit locale routes work.
        if (['127.0.0.1', 'localhost', '[::1]'].includes(location.hostname) || location.hostname.endsWith('.shopifypreview.com')) {
          switcher.addEventListener('submit', event => {
            const code = event.submitter?.dataset.giestoLanguageCode;
            if (!['tr', 'en'].includes(code)) return;
            event.preventDefault();
            const url = new URL(location.href);
            const path = url.pathname.replace(/^\/(?:en|tr)(?=\/|$)/, '') || '/';
            url.pathname = (code === 'en' ? '/en' : '') + path;
            location.assign(url.href);
          });
        }
        control.replaceWith(switcher);
      }
      const searchInput = this.root.querySelector('header input[type="search"]');
      const searchForm = searchInput?.closest('form');
      if (searchInput) {
        searchInput.name = 'q';
        searchInput.placeholder = this.copy.search;
      }
      if (searchForm) {
        searchForm.action = this.config.search || '/search';
        searchForm.method = 'get';
      }
      const searchLabel = searchForm?.querySelector('label');
      if (searchLabel) searchLabel.textContent = this.copy.search;
      if (searchInput && searchForm && !searchForm.querySelector('[data-giesto-header-search-clear]')) {
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.hidden = true;
        clear.dataset.giestoHeaderSearchClear = '';
        clear.className = 'absolute right-0 top-0 h-32 w-32 p-10 text-center tablet:h-36 tablet:w-36 tablet:p-12 desktop:h-40 desktop:w-40 desktop:p-14';
        clear.setAttribute('aria-label', this.locale === 'tr' ? 'Aramayı temizle' : 'Clear search');
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('class', 'fill-current h-12 w-12');
        svg.setAttribute('aria-hidden', 'true');
        const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
        const sprite = this.root.querySelector('svg use')?.getAttribute('href')?.replace(/#.*$/, '') || '';
        use.setAttribute('href', `${sprite}#navigate-close`);
        svg.append(use); clear.append(svg); searchForm.append(clear);
        const syncClear = () => { clear.hidden = !searchInput.value; };
        searchInput.addEventListener('input', syncClear);
        clear.addEventListener('click', event => {
          event.preventDefault(); event.stopPropagation();
          searchInput.value = '';
          syncClear();
          searchInput.focus();
        });
        syncClear();
      }
      this.mobileMenuButton?.setAttribute('aria-label', this.copy.menu);
      const labels = this.locale === 'tr'
        ? ['Ana menü', 'İkincil menü', 'GIESTO ana sayfası']
        : ['Primary navigation', 'Secondary navigation', 'GIESTO home'];
      for (const [oldLabel, label] of [
        ['Primary Navigation Aria Label', labels[0]],
        ['Secondary Navigation Aria Label', labels[1]],
        ['Go to GIESTO start page', labels[2]],
      ]) this.root.querySelectorAll(`[aria-label="${oldLabel}"]`).forEach(element => element.setAttribute('aria-label', label));
      const account = this.root.querySelector('[data-testid="header-account"]');
      const wishlist = this.root.querySelector('[data-testid="header-wishlist"]');
      const cart = this.root.querySelector('[data-testid="header-cart"]');
      if (account) account.setAttribute('aria-label', this.copy.account);
      if (wishlist) {
        wishlist.setAttribute('aria-label', this.copy.wishlist);
        wishlist.href = this.localUrl('/pages/favori');
      }
      if (cart) cart.setAttribute('aria-label', this.copy.cart);
    }

    configureAnnouncement() {
      if (!this.announcementTrigger || !this.announcementDrawer) return;
      const isEnglish = this.locale === 'en';
      const title = isEnglish ? 'Discover new season' : 'Yeni sezonu keşfet';
      const banner = this.announcementTrigger.closest('section');
      const bannerText = isEnglish ? 'NEW ARRIVALS, NEW ESSENTIALS' : 'YENİ GELENLER, YENİ TEMEL PARÇALAR';
      banner.querySelectorAll('p').forEach(p => { p.textContent = bannerText; });
      const mobileCopy = banner.querySelector('div.contents');
      if (mobileCopy && !mobileCopy.textContent.trim()) {
        const copy = document.createElement('p');copy.className = 'text-16 leading-22';copy.textContent = bannerText;mobileCopy.append(copy);
      }
      const plus = banner.querySelector('svg');
      if (plus) { plus.setAttribute('viewBox', '0 0 24 24');plus.innerHTML = '<path d="M12 2v20M2 12h20" fill="none" stroke="currentColor" stroke-width="1.5"/>'; }
      const destinations = {
        basic: ['BASIC', '/collections/basic'],
        'new-season': [isEnglish ? 'NEW SEASON' : 'YENİ SEZON', '/collections/tumunu-gor-f-w27'],
        collections: [isEnglish ? 'COLLECTIONS' : 'KOLEKSİYONLAR', '/collections/all'],
        sale: ['SALE', '/collections/indirim'],
        terms: [isEnglish ? 'Terms and conditions' : 'Şartlar ve koşullar', '/policies/terms-of-service'],
      };
      this.announcementTrigger.dataset.giestoAnnouncementTrigger = '';
      this.announcementTrigger.setAttribute('aria-controls', 'giesto-announcement-drawer');
      this.announcementTrigger.setAttribute('aria-expanded', 'false');
      this.announcementTrigger.setAttribute('aria-label', title);
      this.announcementDrawer.id = 'giesto-announcement-drawer';
      const heading = this.announcementDrawer.querySelector('.giesto-announcement-drawer__title');
      const nav = this.announcementDrawer.querySelector('.giesto-announcement-drawer__navigation');
      if (heading) heading.textContent = title;
      if (nav) nav.setAttribute('aria-label', title);
      for (const [key, [label, path]] of Object.entries(destinations)) {
        const link = this.announcementDrawer.querySelector(`[data-giesto-announcement-link="${key}"]`);
        if (!link) continue;
        link.textContent = label;
        link.href = this.localUrl(path);
      }
      const close = this.announcementDrawer.querySelector('[data-giesto-announcement-close]');
      close?.setAttribute('aria-label', this.copy.close);
      this.announcementDrawer.addEventListener('close', () => {
        this.announcementTrigger?.setAttribute('aria-expanded', 'false');
      });
    }

    openAnnouncement() {
      if (!this.announcementDrawer || this.announcementDrawer.open) return;
      this.setMobileMenu(false);
      this.closeAll();
      this.announcementDrawer.showModal();
      this.announcementTrigger?.setAttribute('aria-expanded', 'true');
    }

    closeAnnouncement() {
      if (!this.announcementDrawer?.open) return;
      this.announcementDrawer.close();
    }

    syncWishlistCount() {
      if (this.root) window.GiestoWishlist?.syncHeader(this.root);
    }

    setPanelState(panel, open) {
      if (!panel) return;
      panel.classList.toggle('h-0', !open);
      panel.classList.remove(...(open ? CLOSED_PANEL_CLASSES : OPEN_PANEL_CLASSES));
      panel.classList.add(...(open ? OPEN_PANEL_CLASSES : CLOSED_PANEL_CLASSES));
    }

    // The source dims the page behind an open desktop panel and freezes the
    // page under it, exactly as the mobile menu does.
    setDesktopOverlay(open) {
      this.mobileMenu?.children[0]?.classList.toggle('opacity-100', open);
      this.mobileMenu?.children[0]?.classList.toggle('opacity-0', !open);
    }

    closeAll() {
      this.setDesktopOverlay(false);
      if (!this.isMobileMenuOpen()) this.setBodyScrollLock(false);
      this.topButtons.forEach((button) => button.classList.remove(...ACTIVE_TAB_CLASSES));
      this.panels.forEach((panel) => this.setPanelState(panel, false));
      for (const nested of this.root.querySelectorAll('button[data-menu*="-"] + div')) this.setPanelState(nested, false);
      for (const button of this.root.querySelectorAll('button[data-menu*="-"]')) {
        button.classList.remove('desktop:pointer-events-none', 'desktop:pl-8');
        button.querySelector('svg')?.classList.remove('rotate-180');
      }
    }

    openTop(button) {
      const index = Number(button.dataset.menu);
      const panel = this.root.querySelector(`header nav > div > div:nth-of-type(${index + 1})`);
      const alreadyOpen = panel?.classList.contains('visible');
      this.closeAll();
      if (alreadyOpen) return;
      button.classList.add(...ACTIVE_TAB_CLASSES);
      this.setPanelState(panel, true);
      this.setDesktopOverlay(true);
      this.setBodyScrollLock(true);
    }

    openNested(button) {
      const panel = button.nextElementSibling;
      if (!panel) return;
      const topPanel = button.closest('header nav > div > div');
      for (const sibling of topPanel?.querySelectorAll('button[data-menu*="-"] + div') || []) {
        if (sibling !== panel) this.setPanelState(sibling, false);
      }
      for (const siblingButton of topPanel?.querySelectorAll('button[data-menu*="-"]') || []) {
        if (siblingButton === button || siblingButton.classList.contains('sticky')) continue;
        siblingButton.classList.remove('desktop:pointer-events-none', 'desktop:pl-8');
        siblingButton.querySelector('svg')?.classList.remove('rotate-180');
      }
      this.setPanelState(panel, true);
      button.querySelector('svg')?.classList.toggle('rotate-180', true);
      if (matchMedia(DESKTOP_QUERY).matches) button.classList.add('desktop:pointer-events-none', 'desktop:pl-8');
    }

    back(button) {
      const level = Number(button.dataset.level || 0);
      if (level === 0) {
        this.closeAll();
        return;
      }
      const submenu = button.closest('div.bottom-0');
      this.setPanelState(submenu, false);
      const parentButton = submenu?.previousElementSibling;
      parentButton?.classList.remove('desktop:pointer-events-none', 'desktop:pl-8');
      parentButton?.querySelector('svg')?.classList.remove('rotate-180');
    }

    isMobileMenuOpen() {
      return Boolean(this.mobileMenu?.classList.contains('left-0'));
    }

    setMenuIcon(open) {
      const use = this.mobileMenuButton?.querySelector('use');
      if (!use) return;
      const href = use.getAttribute('href') || '';
      use.setAttribute('href', href.replace(/#.*$/, `#${open ? MENU_ICON_OPEN : MENU_ICON_CLOSED}`));
      this.mobileMenuButton.setAttribute('aria-label', open ? this.copy.close : this.copy.menu);
    }

    // Matches the source: the page behind the open menu must not scroll or
    // swipe. Only release a lock this header took, so the cart and search
    // drawers keep theirs.
    setBodyScrollLock(locked) {
      if (locked === this.scrollLocked) return;
      this.scrollLocked = locked;
      document.body.style.overflowY = locked ? 'hidden' : 'unset';
    }

    setMobileMenu(open) {
      if (!this.mobileMenu || this.isMobileMenuOpen() === open) return;
      this.mobileMenu.classList.toggle('-left-full', !open);
      this.mobileMenu.classList.toggle('left-0', open);
      this.mobileMenuBackdrop?.classList.toggle('-left-full', !open);
      this.mobileMenuBackdrop?.classList.toggle('left-0', open);
      this.mobileMenuButton?.setAttribute('aria-expanded', String(open));
      this.setMenuIcon(open);
      this.setBodyScrollLock(open);
      if (open) this.updateMenuHeight();
      else this.closeAll();
    }

    toggleMobileMenu() {
      this.setMobileMenu(!this.isMobileMenuOpen());
    }

    // Called by giesto-header-surfaces when it opens the search, account or
    // cart drawer, which capture the click before this header ever sees it.
    closeMobileMenu() {
      this.setMobileMenu(false);
      this.closeAll();
    }

    onClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (target.closest('[data-giesto-announcement-trigger]')) {
        event.preventDefault();
        this.openAnnouncement();
        return;
      }
      if (target.closest('[data-giesto-announcement-close]') || target === this.announcementDrawer) {
        event.preventDefault();
        this.closeAnnouncement();
        return;
      }
      const account = target.closest('[data-testid="header-account"]');
      const cart = target.closest('[data-testid="header-cart"]');
      if (account) {
        this.setMobileMenu(false);
        location.href = this.config.account || '/account';
        return;
      }
      if (cart) {
        this.setMobileMenu(false);
        location.href = this.config.cart || '/cart';
        return;
      }
      if (target.closest('[data-testid="header-navigation-menu-button"]')) {
        event.preventDefault();
        this.toggleMobileMenu();
        return;
      }
      // The source closes the open mobile menu when the tap lands on menu
      // chrome rather than on one of its own controls.
      if (
        this.isMobileMenuOpen()
        && this.mobileMenu?.contains(target)
        && !target.closest('a, button, input, label, form')
      ) {
        this.setMobileMenu(false);
        return;
      }
      const close = target.closest('button');
      if (close && /^(kapat|close)$/i.test(close.textContent.trim())) {
        this.closeAll();
        return;
      }
      const topButton = target.closest('header nav > div > ul > li > button[data-menu]');
      if (topButton) {
        event.preventDefault();
        this.openTop(topButton);
        return;
      }
      const backButton = target.closest('button.sticky[data-level]');
      if (backButton) {
        event.preventDefault();
        this.back(backButton);
        return;
      }
      const nestedButton = target.closest('button[data-menu*="-"]');
      if (nestedButton) {
        event.preventDefault();
        this.openNested(nestedButton);
      }
    }

    /*
     * Turns a measurement taken inside the 0.625 shell into page pixels.
     *
     * Browsers disagree about whether getBoundingClientRect() reports that
     * zoom: engines with standardised `zoom` (Chrome 128+, Safari 18, Firefox
     * 126) return the scaled box, older ones the unscaled layout box. Anything
     * measured in here and then applied outside the shell has to be converted
     * or the two are 1.6x apart -- on the older engines that left the sticky
     * offset below pulling the header a whole logo row off the top of the
     * screen.
     *
     * The host is outside the zoom, so comparing it against the scaled wrapper
     * measures what this engine actually does rather than guessing from a
     * feature test: 1 where the rect already carries the zoom, 0.625 where it
     * does not.
     */
    get pageScale() {
      const scaled = this.root?.querySelector('.giesto-canonical-header-scale');
      const inner = scaled?.getBoundingClientRect().height || 0;
      const outer = this.getBoundingClientRect().height || 0;
      if (!inner || !outer) return 1;
      const factor = outer / inner;
      return factor > 0 && factor <= 1.01 ? factor : 1;
    }

    updateMenuHeight() {
      if (!this.header) return;
      const headerBottom = this.header.getBoundingClientRect().bottom * this.pageScale;
      const height = Math.max(0, window.innerHeight - headerBottom) / HEADER_SCALE;
      this.panels.forEach((panel) => (panel.style.height = `${height}px`));
      // The source sizes the mobile backdrop and the desktop dimmer with
      // h-screen/w-screen, which the 0.625 zoom shrinks to 62.5% of the
      // viewport and leaves the page showing through along two edges.
      if (this.mobileMenuBackdrop) this.mobileMenuBackdrop.style.height = `${height}px`;
      const overlay = this.mobileMenu?.children[0];
      if (overlay) {
        overlay.style.height = `${height}px`;
        overlay.style.width = `${window.innerWidth / HEADER_SCALE}px`;
      }
    }

    // A click outside an open menu only dismisses it: whatever it landed on is
    // NOT activated. This is a deliberate departure -- the reference closes the
    // menu and lets the same click through, measured on all three captures --
    // see README, "Deliberate departures".
    //
    // Capture phase on window, so this runs before the page's own handlers and
    // before giesto-header-surfaces. The menu closes on pointerdown, which is
    // the reference's timing, and the click that follows is swallowed by the
    // latch below -- by then the menu is shut, so `isOpen()` can no longer
    // recognise the pair on its own.
    onOutsidePointerDown(event) {
      if (!this.isOpen()) return;
      if (event.composedPath().includes(this)) return;
      this.swallowClick = true;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.setMobileMenu(false);
      this.closeAll();
    }

    onOutsideClick(event) {
      if (!this.swallowClick) return;
      // Cleared on the first click either way, so a latch can never outlive
      // the gesture that set it.
      this.swallowClick = false;
      if (event.composedPath().includes(this)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    isOpen() {
      return this.isMobileMenuOpen() || this.panels.some((panel) => panel.classList.contains('visible'));
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      if (this.isMobileMenuOpen()) this.setMobileMenu(false);
      else this.closeAll();
    }

    onResize() {
      this.updateMenuHeight();
      if (matchMedia(DESKTOP_QUERY).matches) this.setMobileMenu(false);
      else this.closeAll();
    }
  }

  if (!customElements.get('giesto-canonical-header')) {
    customElements.define('giesto-canonical-header', GiestoCanonicalHeader);
  }
})();
